module.exports = __webpack_public_path__ + "media/images/flowers2-e83d837a3d5227493a927f180a97d345.jpg";